/* eslint-disable ember/no-computed-properties-in-native-classes */
import GlobalNotice from '@linc-technologies/linced-common/models/posts/globalnotice';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import type Group from 'linced-admin/models/schools/group';

export default class Globalnotice extends GlobalNotice {
  declare [Type]: 'posts/globalnotice';

  @hasMany('schools/group', { async: true, inverse: null })
  // @ts-expect-error linced-admin links notices to schools/group, not group.
  declare groupIds: AsyncHasMany<Group>;

  @computed('id')
  get url() {
    return `/hero-notices/${this.id}`;
  }
}
